/* ============================================================
   VENOTAL · storefront behavior
   Recreación del comportamiento del handoff sobre datos reales de
   Shopify (Cart AJAX API + Predictive Search API). Sin localStorage
   para el carrito: la fuente de verdad es Shopify.
   ============================================================ */
(function () {
  'use strict';

  var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';

  /* ---------- utils ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return '$' + value;
  }

  // Predictive search puede devolver price como string ya formateado ("$24.00")
  // o como número en centavos, según la versión de la API. Contemplamos ambos.
  function priceText(p) {
    if (p == null || p.price == null) return '';
    if (typeof p.price === 'number') return formatMoney(p.price);
    return String(p.price);
  }
  function imageUrl(p) {
    if (!p) return '';
    if (p.featured_image && p.featured_image.url) return p.featured_image.url;
    if (typeof p.image === 'string') return p.image;
    if (p.image && p.image.url) return p.image.url;
    return '';
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ============================================================
     Cart badge — refleja el conteo real de Shopify
     ============================================================ */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function refreshCart() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  /* ============================================================
     Fly-to-cart + toast (microinteracción de compra)
     ============================================================ */
  function flyToCart(sourceEl) {
    var cartIcon = document.querySelector('[data-cart-target]');
    if (!sourceEl || !cartIcon) return;

    var from = sourceEl.getBoundingClientRect();
    var to = cartIcon.getBoundingClientRect();

    var clone = document.createElement('div');
    clone.className = 'v-fly';
    clone.style.left = from.left + 'px';
    clone.style.top = from.top + 'px';
    clone.style.width = from.width + 'px';
    clone.style.height = from.height + 'px';
    var bg = getComputedStyle(sourceEl).backgroundImage;
    clone.style.background = bg && bg !== 'none'
      ? bg + ' center/cover'
      : 'radial-gradient(circle at 50% 40%, rgba(138,43,226,.35), transparent 70%), #171717';
    document.body.appendChild(clone);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);

    var anim = clone.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
        { transform: 'translate(' + dx * 0.5 + 'px,' + (dy - 120) + 'px) scale(.6)', opacity: 1, offset: 0.6 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.4, offset: 1 },
      ],
      { duration: 900, easing: 'cubic-bezier(.22,1,.36,1)' }
    );
    anim.onfinish = function () {
      clone.remove();
      var flash = document.createElement('span');
      flash.className = 'v-flash';
      flash.style.left = to.left + to.width / 2 - 9 + 'px';
      flash.style.top = to.top + to.height / 2 - 9 + 'px';
      document.body.appendChild(flash);
      setTimeout(function () { flash.remove(); }, 520);
    };
  }

  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'v-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ============================================================
     Add to cart (tarjetas de producto)
     ============================================================ */
  function addToCart(variantId, sourceEl) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        flyToCart(sourceEl);
        return refreshCart();
      })
      .then(function () {
        toast('Dopamina procesándose… ¡Compra exitosa!');
      })
      .catch(function () {
        toast('No pudimos sumarlo. Probá de nuevo.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-add-variant');
    if (!id) return;
    btn.disabled = true;
    var frame = btn.closest('.v-card') && btn.closest('.v-card').querySelector('.v-card__frame');
    addToCart(id, frame).finally(function () { btn.disabled = false; });
  });

  /* ============================================================
     Cookie consent banner
     ============================================================ */
  function initCookies() {
    var banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    var KEY = 'venotal.cookieConsent';
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (!saved) {
      requestAnimationFrame(function () { banner.classList.add('is-on'); });
    }
    banner.addEventListener('click', function (e) {
      var choice = e.target.closest('[data-cookie-choice]');
      if (!choice) return;
      try {
        localStorage.setItem(KEY, JSON.stringify({ choice: choice.getAttribute('data-cookie-choice'), ts: Date.now() }));
      } catch (err) {}
      banner.classList.remove('is-on');
    });
  }

  /* ============================================================
     Predictive search (API real de Shopify)
     ============================================================ */
  function initSearch() {
    document.querySelectorAll('[data-predictive]').forEach(function (root) {
      var input = root.querySelector('input[type="search"], input[type="text"]');
      var panel = root.querySelector('[data-predictive-panel]');
      if (!input || !panel) return;

      var searchRoot = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json';

      function open() { root.classList.add('is-open'); }
      function close() { root.classList.remove('is-open'); }

      function skeleton() {
        var html = '';
        for (var i = 0; i < 3; i++) {
          html += '<div class="v-skel-row"><div class="v-skel-thumb"></div>' +
            '<div class="v-skel-lines"><div class="v-skel-line"></div><div class="v-skel-line sm"></div></div></div>';
        }
        panel.innerHTML = html;
      }

      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function render(data, q) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
        var html = '';

        if (products.length) {
          html += '<div class="v-predictive__group"><div class="v-predictive__label">Productos</div>';
          products.slice(0, 4).forEach(function (p) {
            var img = imageUrl(p);
            var thumb = img
              ? '<img class="v-pred-row__thumb" src="' + esc(img) + '" alt="" loading="lazy">'
              : '<span class="v-pred-row__thumb"></span>';
            html += '<a class="v-pred-row" href="' + esc(p.url) + '">' + thumb +
              '<span class="v-pred-row__body"><span class="v-pred-row__name">' + esc(p.title) + '</span>' +
              '<span class="v-pred-row__meta">' + esc(p.vendor || (p.type || '')) + '</span></span>' +
              '<span class="v-pred-row__price">' + esc(priceText(p)) + '</span></a>';
          });
          html += '</div>';
        }

        if (collections.length) {
          html += '<div class="v-predictive__group"><div class="v-predictive__label">Colecciones</div>';
          collections.slice(0, 3).forEach(function (c) {
            html += '<a class="v-pred-row v-pred-coll" href="' + esc(c.url) + '"><span>◆</span>' + esc(c.title) + '</a>';
          });
          html += '</div>';
        }

        if (!products.length && !collections.length) {
          html += '<div class="v-predictive__empty">Nada por acá. Probá con menos exigencia.</div>';
        }

        var searchUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search?q=' + encodeURIComponent(q);
        html += '<a class="v-predictive__all" href="' + esc(searchUrl) + '">Ver todos los resultados para “' + esc(q) + '” <span>→</span></a>';

        panel.innerHTML = '<div class="v-predictive__scroll">' + html + '</div>';
      }

      var run = debounce(function () {
        var q = input.value.trim();
        if (!q) { close(); return; }
        var url = searchRoot + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=4&section_id=';
        fetch(url, { headers: { 'Content-Type': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) { render(data, q); open(); })
          .catch(function () { close(); });
      }, 300);

      input.addEventListener('input', function () {
        if (input.value.trim()) { skeleton(); open(); run(); } else { close(); }
      });
      input.addEventListener('focus', function () { if (input.value.trim()) open(); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); input.blur(); }
      });
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) close();
      });
    });
  }

  function root() {
    return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  }

  /* ============================================================
     Sort dropdowns (collection + search)
     ============================================================ */
  function initSortDropdowns() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sort-btn]');
      document.querySelectorAll('[data-sort].is-open').forEach(function (s) {
        if (!btn || !s.contains(btn)) s.classList.remove('is-open');
      });
      if (btn) {
        var sort = btn.closest('[data-sort]');
        if (sort) sort.classList.toggle('is-open');
      }
    });
  }

  /* ============================================================
     Collection controls: filters toggle + density
     ============================================================ */
  function initCollectionControls() {
    var toggle = document.querySelector('[data-filters-toggle]');
    var layout = document.querySelector('[data-coll-layout]');
    if (toggle && layout) {
      var label = toggle.querySelector('[data-filters-label]');
      toggle.addEventListener('click', function () {
        var hidden = layout.classList.toggle('filters-hidden');
        if (label) label.textContent = hidden ? 'Filtros' : 'Ocultar filtros';
      });
    }

    var densityBox = document.querySelector('[data-density-toggle]');
    var target = document.querySelector('[data-density-target]');
    if (densityBox && target) {
      var KEY = 'venotal.density';
      var saved = null;
      try { saved = localStorage.getItem(KEY); } catch (e) {}
      if (!saved && window.innerWidth < 820) saved = '2';
      if (saved) target.setAttribute('data-density', saved);
      function markActive() {
        var cur = target.getAttribute('data-density');
        densityBox.querySelectorAll('button[data-density]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-density') === cur);
        });
      }
      markActive();
      densityBox.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-density]');
        if (!b) return;
        var n = b.getAttribute('data-density');
        target.setAttribute('data-density', n);
        try { localStorage.setItem(KEY, n); } catch (err) {}
        markActive();
      });
    }
  }

  /* ============================================================
     Product: gallery, video, variants, wishlist, add
     ============================================================ */
  function initProduct() {
    var product = document.querySelector('[data-product]');
    if (!product) return;

    // gallery thumbnails
    var main = product.querySelector('[data-gallery-main]');
    product.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && main.tagName === 'IMG' && full) main.src = full;
        product.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // galería completa (modal)
    var modal = product.querySelector('[data-gallery-modal]');
    if (modal) {
      var moreBtn = product.querySelector('[data-gallery-more]');
      var ultimoFoco = null;

      function abrirGaleria() {
        ultimoFoco = document.activeElement;
        modal.hidden = false;
        // Bloquea el scroll de fondo: sin esto, en móvil se scrollea la página
        // detrás del modal y se pierde la posición al cerrar.
        document.body.style.overflow = 'hidden';
        var primero = modal.querySelector('[data-gallery-pick]');
        if (primero) primero.focus();
      }

      function cerrarGaleria() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
      }

      if (moreBtn) moreBtn.addEventListener('click', abrirGaleria);

      modal.querySelectorAll('[data-gallery-close]').forEach(function (b) {
        b.addEventListener('click', cerrarGaleria);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) cerrarGaleria();
      });

      // Elegir una foto la sube a la principal y cierra: el modal es para
      // encontrarla, no para quedarse adentro.
      modal.querySelectorAll('[data-gallery-pick]').forEach(function (item) {
        item.addEventListener('click', function () {
          var full = item.getAttribute('data-full');
          if (main && main.tagName === 'IMG' && full) main.src = full;
          product.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.remove('is-active');
          });
          cerrarGaleria();
        });
      });
    }

    // video
    var playBtn = product.querySelector('[data-video-play]');
    if (playBtn) {
      var frame = product.querySelector('[data-gallery-frame]');
      playBtn.addEventListener('click', function () {
        frame.classList.add('playing');
        var vid = frame.querySelector('video');
        if (vid) { try { vid.play(); } catch (e) {} }
      });
    }

    // variants
    var dataEl = product.querySelector('[data-variants]');
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }
    var idInput = product.querySelector('[data-variant-id]');
    var priceEl = product.querySelector('[data-price]');
    var compareEl = product.querySelector('[data-compare]');
    var badgeEl = product.querySelector('[data-badge]');
    var addBtn = product.querySelector('[data-add-submit]');

    function currentOptions() {
      var opts = [];
      product.querySelectorAll('.v-pdp__opt').forEach(function (group) {
        var checked = group.querySelector('[data-option-input]:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateVariant() {
      if (!variants.length) return;
      var opts = currentOptions();
      var v = findVariant(opts);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare; compareEl.style.display = v.on_sale ? '' : 'none'; }
      if (badgeEl) badgeEl.style.display = v.on_sale ? '' : 'none';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      }
      if (main && main.tagName === 'IMG' && v.media) main.src = v.media;
      // update selected color label
      product.querySelectorAll('.v-pdp__opt').forEach(function (group) {
        var lbl = group.querySelector('[data-option-selected]');
        var checked = group.querySelector('[data-option-input]:checked');
        if (lbl && checked) lbl.textContent = checked.value;
      });
    }
    product.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    // wishlist
    var wishBtn = product.querySelector('[data-wish]');
    if (wishBtn) {
      var WKEY = 'venotal.wishlist';
      function readWish() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
      function writeWish(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
      var id = wishBtn.getAttribute('data-wish-id');
      function reflect() {
        var on = readWish().some(function (w) { return String(w.id) === String(id); });
        wishBtn.classList.toggle('is-on', on);
        wishBtn.textContent = on ? '♥' : '♡';
        wishBtn.setAttribute('aria-label', on ? 'Quitar de deseos' : 'Guardar en deseos');
      }
      reflect();
      wishBtn.addEventListener('click', function () {
        var list = readWish();
        var idx = list.findIndex(function (w) { return String(w.id) === String(id); });
        if (idx >= 0) list.splice(idx, 1);
        else list.push({ id: id, handle: wishBtn.getAttribute('data-wish-handle'), title: wishBtn.getAttribute('data-wish-title') });
        writeWish(list);
        reflect();
      });
    }

    // add to cart (AJAX + fly-to-cart)
    var form = product.querySelector('[data-product-form]');
    var buyNowBtn = product.querySelector('[data-buy-now]');
    // Los dos botones envían el mismo form; el submitter dice si hay que ir al checkout.
    var goToCheckout = false;
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () { goToCheckout = true; });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var checkout = goToCheckout;
        goToCheckout = false;
        var id = idInput ? idInput.value : null;
        if (!id || (addBtn && addBtn.disabled)) return;
        if (addBtn) addBtn.disabled = true;
        if (buyNowBtn) buyNowBtn.disabled = true;
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            if (checkout) { window.location.href = root() + 'checkout'; return null; }
            flyToCart(product.querySelector('[data-gallery-frame]'));
            return refreshCart();
          })
          .then(function (res) { if (res !== null) toast('Dopamina procesándose… ¡Compra exitosa!'); })
          .catch(function () { toast('No pudimos sumarlo. Probá de nuevo.'); })
          .finally(function () {
            // En el camino al checkout no se rehabilitan: la página ya se está yendo.
            if (checkout) return;
            if (addBtn) addBtn.disabled = false;
            if (buyNowBtn) buyNowBtn.disabled = false;
          });
      });
    }
  }

  /* ============================================================
     Cart page: stepper / remove (Cart AJAX + section re-render), discount
     ============================================================ */
  function cartSectionOf(el) { return el.closest('[id^="shopify-section-"]'); }

  function cartChange(key, quantity, wrapper) {
    var sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : null;
    var body = { id: key, quantity: quantity };
    if (sectionId) { body.sections = sectionId; body.sections_url = '/cart'; }
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        if (wrapper && cart.sections && cart.sections[sectionId] != null) {
          wrapper.innerHTML = cart.sections[sectionId];
        }
      });
  }

  function initCartPage() {
    if (!document.querySelector('[data-cart-page]')) return;

    document.addEventListener('click', function (e) {
      var line = e.target.closest('.v-cart-line');
      var wrapper = cartSectionOf(document.querySelector('[data-cart-page]'));

      var inc = e.target.closest('[data-qty-inc]');
      var dec = e.target.closest('[data-qty-dec]');
      var rem = e.target.closest('[data-line-remove]');

      if ((inc || dec) && line) {
        var qtyEl = line.querySelector('[data-qty]');
        var cur = parseInt(qtyEl.textContent, 10) || 1;
        var next = inc ? cur + 1 : Math.max(1, cur - 1);
        if (next === cur) return;
        cartChange(line.getAttribute('data-line-key'), next, wrapper);
      }

      if (rem && line) {
        line.classList.add('removing');
        setTimeout(function () {
          cartChange(line.getAttribute('data-line-key'), 0, wrapper);
        }, 400);
      }

      var apply = e.target.closest('[data-disc-apply]');
      if (apply) {
        var box = apply.closest('[data-disc]');
        var input = box.querySelector('[data-disc-code]');
        var code = (input.value || '').trim();
        if (code) window.location.href = root() + 'discount/' + encodeURIComponent(code) + '?redirect=/cart';
      }
    });
  }

  /* ============================================================
     Auth: login / recover toggle
     ============================================================ */
  function initAuth() {
    var auth = document.querySelector('[data-auth]');
    if (!auth) return;
    function show(recover) { auth.classList.toggle('showing-recover', recover); }
    auth.querySelectorAll('[data-show-recover]').forEach(function (b) {
      b.addEventListener('click', function () { show(true); });
    });
    auth.querySelectorAll('[data-show-login]').forEach(function (b) {
      b.addEventListener('click', function () { show(false); });
    });
    if (window.location.hash === '#recover' ||
        auth.querySelector('[data-recover-posted]') ||
        auth.querySelector('.v-recover .v-form-note')) {
      show(true);
    }
  }

  /* ============================================================
     Account: client-side tabs
     ============================================================ */
  function initAccountTabs() {
    var acc = document.querySelector('[data-account]');
    if (!acc) return;
    acc.querySelectorAll('[data-account-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-account-tab');
        acc.querySelectorAll('[data-account-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        acc.querySelectorAll('[data-account-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-account-panel') === name);
        });
      });
    });
  }

  /* ============================================================
     Addresses: new/edit form toggles
     ============================================================ */
  function initAddresses() {
    var box = document.querySelector('[data-addresses]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var newT = e.target.closest('[data-addr-new-toggle]');
      if (newT) {
        e.preventDefault();
        var f = box.querySelector('[data-addr-new]');
        if (f) f.hidden = !f.hidden;
        return;
      }
      var editT = e.target.closest('[data-addr-edit-toggle]');
      if (editT) {
        e.preventDefault();
        var id = editT.getAttribute('data-addr-edit-toggle');
        var ef = box.querySelector('[data-addr-edit="' + id + '"]');
        if (ef) ef.hidden = !ef.hidden;
      }
    });
  }

  /* ============================================================
     Wishlist page (client-side, hydrated from /products/{handle}.js)
     ============================================================ */
  function initWishlist() {
    var wl = document.querySelector('[data-wishlist]');
    if (!wl) return;
    var grid = wl.querySelector('[data-wishlist-grid]');
    var empty = wl.querySelector('[data-wishlist-empty]');
    var countEl = document.querySelector('[data-wishlist-count]');
    var tmpl = document.querySelector('[data-wish-card-template]');
    var WKEY = 'venotal.wishlist';

    function read() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
    function write(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
    function absUrl(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }

    function render() {
      var list = read();
      grid.innerHTML = '';
      if (!list.length) {
        grid.hidden = true; empty.hidden = false;
        if (countEl) countEl.textContent = 'Tu autocontrol, por ahora, gana.';
        return;
      }
      empty.hidden = true; grid.hidden = false;
      if (countEl) {
        countEl.textContent = list.length + (list.length === 1 ? ' objeto esperando' : ' objetos esperando') +
          ' una excusa para dejar de ser deseo.';
      }
      list.forEach(function (item) {
        var node = tmpl.content.firstElementChild.cloneNode(true);
        node.querySelector('[data-wish-title]').textContent = item.title || item.handle;
        node.querySelector('[data-wish-url]').href = root() + 'products/' + item.handle;

        node.querySelector('[data-wish-remove]').addEventListener('click', function () {
          write(read().filter(function (w) { return String(w.id) !== String(item.id); }));
          render();
        });
        var moveBtn = node.querySelector('[data-wish-move]');
        grid.appendChild(node);

        // hydrate with real product data
        fetch(root() + 'products/' + item.handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var img = node.querySelector('[data-wish-img]');
            if (p.featured_image) { img.src = absUrl(p.featured_image); img.alt = p.title; }
            else { img.classList.add('v-card__img--ph'); }
            node.querySelector('[data-wish-cat]').textContent = p.type || '';
            node.querySelector('[data-wish-price]').textContent = formatMoney(p.price);
            var variantId = p.variants && p.variants[0] && p.variants[0].id;
            moveBtn.addEventListener('click', function () {
              if (!variantId) return;
              moveBtn.disabled = true;
              addToCart(variantId, node.querySelector('.v-card__frame')).then(function () {
                write(read().filter(function (w) { return String(w.id) !== String(item.id); }));
                render();
              });
            });
          })
          .catch(function () { node.querySelector('[data-wish-img]').classList.add('v-card__img--ph'); });
      });
    }
    render();
  }

  /* ============================================================
     Content page: TOC generation + scrollspy + collapse
     ============================================================ */
  function initDocToc() {
    var doc = document.querySelector('[data-doc]');
    if (!doc) return;
    var body = doc.querySelector('[data-doc-body]');
    var toc = doc.querySelector('[data-toc]');
    var list = doc.querySelector('[data-toc-list]');
    if (!body || !toc || !list) return;

    var headings = body.querySelectorAll('h2');
    if (headings.length < 2) return;

    var links = [];
    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'doc-sec-' + (i + 1);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      list.appendChild(a);
      links.push(a);
    });
    toc.hidden = false;

    var toggle = doc.querySelector('[data-toc-toggle]');
    if (toggle) toggle.addEventListener('click', function () { toc.classList.toggle('collapsed'); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var id = en.target.id;
            links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + id); });
          }
        });
      }, { rootMargin: '-90px 0px -70% 0px' });
      headings.forEach(function (h) { io.observe(h); });
    }
  }

  /* ============================================================
     FAQ: search + category filter
     ============================================================ */
  function initFaq() {
    var faq = document.querySelector('[data-faq]');
    var list = document.querySelector('[data-faq-list]');
    if (!faq || !list) return;
    var search = faq.querySelector('[data-faq-search]');
    var items = list.querySelectorAll('[data-faq-item]');
    var empty = list.querySelector('[data-faq-empty]');
    var activeCat = '';

    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (it) {
        var matchCat = !activeCat || it.getAttribute('data-cat') === activeCat;
        var matchText = !q || it.textContent.toLowerCase().indexOf(q) >= 0;
        var ok = matchCat && matchText;
        it.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (empty) empty.style.display = shown === 0 ? 'block' : 'none';
    }
    if (search) search.addEventListener('input', apply);
    faq.querySelectorAll('[data-faq-cat]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeCat = chip.getAttribute('data-faq-cat');
        faq.querySelectorAll('[data-faq-cat]').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        apply();
      });
    });
  }

  /* ============================================================
     Animated counters (manifesto)
     ============================================================ */
  function initCounters() {
    var nums = document.querySelectorAll('[data-count-to]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        obs.unobserve(el);
        var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null, dur = 1400;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var val = Math.floor((1 - Math.pow(1 - p, 3)) * target);
          el.textContent = val.toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = target.toLocaleString() + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ============================================================
     Reveal-on-scroll
     ============================================================ */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('revealed'); obs.unobserve(en.target); }
      });
    }, { threshold: 0.14 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     404 glitch: swap heading copy on hover
     ============================================================ */
  function init404() {
    var big = document.querySelector('[data-glitch]');
    var heading = document.querySelector('[data-glitch-heading]');
    if (!big || !heading) return;
    var alts = (big.getAttribute('data-alt') || '').split('|').filter(Boolean);
    if (!alts.length) return;
    var original = heading.textContent;
    var i = 0;
    big.addEventListener('mouseenter', function () {
      heading.textContent = alts[i % alts.length];
      i++;
    });
    big.addEventListener('mouseleave', function () { heading.textContent = original; });
  }

  /* ---------- boot ---------- */
  function boot() {
    initCookies();
    initSearch();
    initSortDropdowns();
    initCollectionControls();
    initProduct();
    initCartPage();
    initAuth();
    initAccountTabs();
    initAddresses();
    initWishlist();
    initDocToc();
    initFaq();
    initCounters();
    initReveal();
    init404();
    refreshCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
